// src/components/LikeDislike/Buttons/LikeButton.tsx

import React, { useState } from "react";
import { AskResponse, FeedBackReq } from "../../../api";
import { sendDataLikeDislikeButton } from "../../../api";
import { useKeepData } from "../CustomHooks";
import { getDateWithFormat, getTimeWithFormat } from "../../../scripts/globalFunctions";
import ThumbUp from "../../../assets/svgComponents/ThumbUp";
import ThumbUpDark from "../../../assets/svgComponents/ThumbUpDark";
import { useUser } from "../../../contexts/useUserData";

import styles from "../buttonAndModalStyles.module.css";

interface PropsData {
    answer: [user: string, response: AskResponse];
    feedbackStatus: 'none' | 'liked' | 'disliked' | undefined;
    setFeedback: (type: 'like' | 'dislike', index: number) => void;
    index: number;
}

export const LikeButton: React.FC<PropsData> = ({ answer, index, feedbackStatus, setFeedback }) => {
    const keepData = useKeepData();
    const { user, token } = useUser();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const answerClicked = async () => {
        if (feedbackStatus !== 'none' || isSubmitting) return;
        setIsSubmitting(true);
        const startTime = Date.now();
        try {
            const date = new Date();
            keepData.setQuestion(answer[0]);
            keepData.setMessageId(answer[1].messageId || "");
            keepData.setAnswer(answer[1].answer);
            keepData.setScope(answer[1].scope);
            keepData.setNegocio(answer[1].negocio);
            keepData.setAcceso(answer[1].acceso);
            keepData.setCentro(answer[1].centro);
            keepData.setLinks(answer[1].links);
            keepData.setAzsLinks(answer[1].azs_links);
            if (answer[1].question_intention) {
                keepData.setQuestionIntention(answer[1].question_intention);
            }
            if (answer[1].selected_button) {
                keepData.setSelectedButton(answer[1].selected_button);
            }
            if (answer[1].language) {
                keepData.setLanguage(answer[1].language);
            }
            if (answer[1].chain_of_thought) {
                keepData.setChainOfThought(answer[1].chain_of_thought);
            }
            keepData.setDate(getDateWithFormat(date));
            keepData.setTime(getTimeWithFormat(date));
            const dataSend: FeedBackReq = {
                messageId: keepData.data.messageId,
                Question: keepData.data.question,
                Answer: keepData.data.answer,
                Scope: keepData.data.scope,
                Negocio: keepData.data.negocio,
                Acceso: keepData.data.acceso,
                Centro: keepData.data.centro,
                Docs_respuesta: keepData.data.links,
                Docs_otros_enlaces: keepData.data.azs_links,
                Content: {
                    OK: true,
                    FeedbackComment: ""
                },
                Links: {
                    OK: true,
                    FeedbackComment: ""
                },
                Reason: {
                    OK: true,
                    FeedbackComment: ""
                },
                OverallFeedback: "OK",
                PartitionKey: keepData.data.time,
                ButtonClickTime: startTime,
                selected_button: keepData.data.selected_button,
                question_intention: keepData.data.question_intention,
                language: keepData.data.language,
                chain_of_thought: keepData.data.chain_of_thought
            };
            let final_token = "";
            if (token) {
                final_token = token;
            }
            const result = await sendDataLikeDislikeButton(dataSend, final_token);
            console.log(result);
            setFeedback("like", index);
        } catch (error) {
            console.error("Error sending like feedback:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const isClicked = feedbackStatus === 'liked';
    const isDisabled = feedbackStatus !== 'none' && feedbackStatus !== undefined;

    return (
        <div>
            <button
                id={`buttonLike-${index}`}
                className={`${styles.like} ${isClicked ? styles["active"] : ""} ${styles.tooltiplike}`}
                type="button"
                onClick={answerClicked}
                disabled={isDisabled || isSubmitting}
            >
                {isClicked ? <ThumbUpDark /> : <ThumbUp />} 
                {!isClicked && feedbackStatus !== 'disliked' && (
                    <span className={styles.tooltipliketext}>Respuesta Correcta</span>
                )}        
            </button>

        </div>
    );
};
